module.exports = __webpack_public_path__ + "img/safety.9b2f9f2f.svg";